
export const environment = {
    production: true,
    API_BASE_PATH: 'https://admin.bydcash.com:8085/'
}
